import { configureStore } from '@reduxjs/toolkit'
import appReducer from './appSlice'

export const store = configureStore({
  reducer: {
    appReducer: appReducer,
  },
})